/**
 * Copyright 2026 AutoZone, Inc.
 * Content is confidential to and proprietary information of AutoZone, Inc., its
 * subsidiaries and affiliates.
 */
import type { OptIn } from '../../myProfile/interface';

export const addOptIn = (optins: OptIn[] | null, opted: OptIn) =>
  Array.from(new Set<OptIn>([...(optins ?? []), opted]));
